<template>
  <section class="call-to-action py-5">
    <div class="container">
      <div class="row justify-content-around align-items-center">
        <div class="col-md-7">
          <div class="subscribe-content">
            <h3 class="mb-1 d-flex align-items-center gap-2">
              <img :src="logoImage" alt="Logo" class="img-fluid" style="max-height: 50px;" />
              {{ t('call_to_action.title') }}
            </h3>
            <p>{{ t('call_to_action.description') }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="action-btn text-lg-right text-sm-left">
            <a href="/accounts/sign_in" class="btn secondary-solid-btn">
              {{ t('call_to_action.login') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const logoImage = new URL('@/assets/ai/log_50.jpg', import.meta.url).href
</script>
